<template>
  <div class="home">
    <div class="banner">
      <div class="xcom">
        <h3>
          <i class="iconfont iconX"></i>
          <span>联</span>
          <span>网</span>
        </h3>
        <p>用 数 据 见 证 产 业 升 级</p>
        <p>Using Data to Witness Industrial Upgrading</p>
      </div>
      <el-carousel height="400px" :interval="5000" indicator-position="none">
        <el-carousel-item v-for="item in 1" :key="item" >
          <img src="@/assets/pc/images/banner_home.jpg" alt />
        </el-carousel-item>
      </el-carousel>
    </div>

    <div
      class="section1 text-center"
      ref="section1"
      v-show="section1RenderShow"
    >
      <transition name="fadeDown">
        <div v-if="section1Render">
          <h2>农业是中国未来10年最有前景的产业</h2>
          <p>新基建给农业发展提供了新契机</p>
        </div>
      </transition>
      <ul class="clear">
        <transition name="fadeUp">
          <li v-if="section1Render">
            <img src="@/assets/lib/images/sec_03.png" alt />
            <p>农业+互联网=农业产业互联网</p>
          </li>
        </transition>
        <transition name="fadeUp">
          <li v-if="section1Render">
            <img src="@/assets/lib/images/sec_05.png" alt />
            <p>农业+人工智能=智慧农业</p>
          </li>
        </transition>
        <transition name="fadeUp">
          <li v-if="section1Render">
            <img src="@/assets/lib/images/sec_07.png" alt />
            <p>农业+大数据=农业大数据</p>
          </li>
        </transition>
      </ul>
    </div>
    <div
      class="section2 text-center"
      ref="section2"
      v-show="section2RenderShow"
    >
      <h2>
        我们的解决方案：&nbsp;
        <em class="c_color">X联网</em>
      </h2>
      <p>
        结合大数据、人工智能、产业互联网先进技术，对农业各领域、各环节进行数字化升级，沉淀农业产业大数据
        促进农业管理智能化、交易电商化、服务线上化、金融场景化、产品品牌化，推动农业数字化升级。
      </p>
      <div class="circleCont">
        <div class="circle-big routed"></div>
        <div class="circle-small routed"></div>
        <ul class="centerCont">
          <li @click="$router.push('/solution/3')">
            现代农业产业园数字化解决方案
          </li>
          <li @click="$router.push('/solution/0')">乡村振兴数字化解决方案</li>
          <li @click="$router.push('/solution/1')">
            农业单品行业大数据解决方案
          </li>
          <li @click="$router.push('/solution/4')">
            农产品区域公用品牌数字化解决方案
          </li>
          <li @click="$router.push('/solution/5')">
            农产品交易中心数字化解决方案
          </li>
          <li @click="$router.push('/solution/2')">
            农业链主企业数字化解决方案
          </li>
        </ul>
      </div>
      <div class="btn_color">农业产业大数据-农业大脑</div>
    </div>

    <div
      class="section3 text-center"
      ref="section3"
      v-show="section3RenderShow"
    >
      <h2>
        我们的服务 &nbsp;
        <em class="c_color">一技四资</em>
      </h2>
      <p>以技术输出为基础，咨询、资源、资金、资本相结合</p>
      <ul class="w1200 clear">
        <transition name="fadeLeft">
          <li v-if="section3Render">
            <img src="@/assets/lib/images/sec1_12.png" alt />
            <div class="discription">
              <h3>技术输出</h3>
              <p>
                基于猪联网，结合团队对产业互联网的深刻理解，整体搭建行业的产业互联网平台
              </p>
            </div>
          </li>
        </transition>
        <transition name="fadeRight">
          <li v-if="section3Render">
            <img src="@/assets/lib/images/sec1_03.png" alt />
            <div class="discription">
              <h3>咨询</h3>
              <p>
                以猪联网产品设计和运营为经验，对项目进行前期咨询，形成专家意见
              </p>
            </div>
          </li>
        </transition>
        <transition name="fadeLeft">
          <li v-if="section3Render">
            <img src="@/assets/lib/images/sec1_05.png" alt />
            <div class="discription">
              <h3>资源</h3>
              <p>提供一站式交钥匙工程，集合多个商家服务</p>
            </div>
          </li>
        </transition>
        <transition name="fadeRight">
          <li v-if="section3Render">
            <img src="@/assets/lib/images/sec1_07.png" alt />
            <div class="discription">
              <h3>资金</h3>
              <p>
                链接农信小贷或其他资金端公司为平台用户提供融资及其他金融业务
              </p>
            </div>
          </li>
        </transition>
        <transition name="fadeLeft">
          <li v-if="section3Render">
            <img src="@/assets/lib/images/sec1_09.png" alt />
            <div class="discription">
              <h3>资本</h3>
              <p>整合农信产业基金，做平台融资财务顾问</p>
            </div>
          </li>
        </transition>
      </ul>
    </div>

    <div
      class="section4 text-center"
      ref="section4"
      v-show="section4RenderShow"
    >
      <h2>成功案例</h2>
      <ul class="w1200 clear">
        <transition name="zoom">
          <li v-if="section4Render">
            <img src="@/assets/lib/images/sec2_09.png" alt />
            <div class="d_title">
              <span>玉米联网</span>
            </div>
            <div class="discription">
              <h3>玉米联网</h3>
              <p>北大荒垦丰种业玉米全流程大数据平台</p>
              <div class="button" @click="routerPush('/home/demo/kfw')">
                了解详情
              </div>
            </div>
          </li>
        </transition>
        <transition name="zoom">
          <li v-if="section4Render">
            <img src="@/assets/lib/images/sec2_17.png" alt />
            <div class="d_title">
              <span>马铃薯联网</span>
            </div>
            <div class="discription">
              <h3>马铃薯联网</h3>
              <p>
                乌兰察布(中国薯都)以马铃薯为抓手，通过数字化手段，实现产业聚集发展，带动区域经济
              </p>
              <div class="button" @click="routerPush('/home/demo/hsw')">
                了解详情
              </div>
            </div>
          </li>
        </transition>
        <transition name="zoom">
          <li v-if="section4Render">
            <img src="@/assets/lib/images/sec2_19.png" alt />
            <div class="d_title">
              <span>柑橘联网</span>
            </div>
            <div class="discription">
              <h3>柑橘联网</h3>
              <p>重庆忠县（全国柑橘主产地）“忠橙”品牌数字化解决方案</p>
              <div class="button" @click="routerPush('/home/demo/gjw')">
                了解详情
              </div>
            </div>
          </li>
        </transition>
        <transition name="zoom">
          <li v-if="section4Render">
            <img src="@/assets/lib/images/sec2_15.png" alt />
            <div class="d_title">
              <span>银耳联网</span>
            </div>
            <div class="discription">
              <h3>银耳联网</h3>
              <p>福建省古田县现代农业产业园（全国银耳主产区）数字化服务平台</p>
              <div class="button" @click="routerPush('/home/demo/jlw')">
                了解详情
              </div>
            </div>
          </li>
        </transition>
        <transition name="zoom">
          <li v-if="section4Render">
            <img src="@/assets/lib/images/sec2_03.png" alt />
            <div class="d_title">
              <span>猪联网</span>
            </div>
            <div class="discription">
              <h3>猪联网</h3>
              <p>猪服务，猪交易，猪金融为一体的整体方案</p>
              <div class="button" @click="routerPush('/home/demo/zlw')">
                了解详情
              </div>
            </div>
          </li>
        </transition>
        
        <transition name="zoom">
          <li v-if="section4Render">
            <img src="@/assets/lib/images/sec2_02.png" alt />
            <div class="d_title">
              <span>羊联网</span>
            </div>
            <div class="discription">
              <h3>羊联网</h3>
              <p>肉羊全产业链数字化服务平台，打造“奥群”品牌羊肉</p>
              <div class="button" @click="routerPush('/home/demo/ylw')">
                了解详情
              </div>
            </div>
          </li>
        </transition>
        
        <transition name="zoom">
          <li v-if="section4Render">
            <img src="@/assets/lib/images/sec2_05.png" alt />
            <div class="d_title">
              <span>驴联网</span>
            </div>
            <div class="discription">
              <h3>驴联网</h3>
              <p>
                东阿阿胶借助数字化平台，从“一张皮到一块胶”
                升级到“一头驴到一块胶”
                对供应链进行全链条数字化改造，提升品牌价值
              </p>
              <div class="button" @click="routerPush('/home/demo/llw')">
                了解详情
              </div>
            </div>
          </li>
        </transition>
        <transition name="zoom">
          <li v-if="section4Render">
            <img src="@/assets/lib/images/sec2_11.png" alt />
            <div class="d_title">
              <span>蛋联网</span>
            </div>
            <div class="discription">
              <h3>蛋联网</h3>
              <p>
                德青源打造供应链数字化平台，转型成为标准商、服务商、品牌商，最大化企业价值
              </p>
              <div class="button" @click="routerPush('/home/demo/dlw')">
                了解详情
              </div>
            </div>
          </li>
        </transition>
        <transition name="zoom">
          <li v-if="section4Render">
            <img src="@/assets/lib/images/sec2_07.png" alt />
            <div class="d_title">
              <span>狐联网</span>
            </div>
            <div class="discription">
              <h3>狐联网</h3>
              <p>以狐狸产业数字化为入口的皮草产业链整合解决方案</p>
              <div class="button" @click="routerPush('/home/demo/hlw')">
                了解详情
              </div>
            </div>
          </li>
        </transition>
        <transition name="zoom">
          <li v-if="section4Render">
            <img src="@/assets/lib/images/sec2_22.jpg" alt />
            <div class="d_title">
              <span>草都云</span>
            </div>
            <div class="discription">
              <h3>草都云</h3>
              <p>草畜一体化园区综合解决方案</p>
              <div class="button" @click="routerPush('/home/demo/cdy')">
                了解详情
              </div>
            </div>
          </li>
        </transition>
        <transition name="zoom">
          <li v-if="section4Render">
            <img src="@/assets/lib/images/sec2_23.jpg" alt />
            <div class="d_title">
              <span>文峰</span>
            </div>
            <div class="discription">
              <h3>文峰</h3>
              <p>南通本地最大市民综合服务平台解决方案</p>
              <div class="button" @click="routerPush('/home/demo/wfh')">
                了解详情
              </div>
            </div>
          </li>
        </transition>
        <transition name="zoom">
          <li v-if="section4Render">
            <img src="@/assets/lib/images/sec_06.png" alt />
            <div class="d_title">
              <span>数字汇源</span>
            </div>
            <div class="discription">
              <h3>数字汇源</h3>
              <p>汇源集团（中国果汁行业第一品牌）全产业链数字化服务平台，打造“数字汇源”</p>
              <div class="button" @click="routerPush('/home/demo/hy')">
                了解详情
              </div>
            </div>
          </li>
        </transition>
        <transition name="zoom">
          <li v-if="section4Render">
            <img src="@/assets/lib/images/sec2_13.png" alt />
            <div class="d_title">
              <span>大蒜现货交易中心</span>
            </div>
            <div class="discription">
              <h3>大蒜现货交易中心</h3>
              <p>河南开封杞县大蒜现货交易市场数字化解决方案</p>
              <div class="button" @click="routerPush('/home/demo/dsw')">
                了解详情
              </div>
            </div>
          </li>
        </transition>
        <transition name="zoom">
          <li v-if="section4Render">
            <img src="@/assets/lib/images/sec2_21.png" alt />
            <div class="d_title">
              <span>国家生猪市场</span>
            </div>
            <div class="discription">
              <h3>国家生猪市场</h3>
              <p>重庆荣昌国家级生猪市场数字化平台升级解决方案</p>
              <div class="button" @click="routerPush('/home/demo/zjs')">
                了解详情
              </div>
            </div>
          </li>
        </transition>
        <transition name="zoom"> 
          <li v-if="section4Render">
            <img src="@/assets/lib/images/sec2_24.jpg" alt />
            <div class="d_title">
              <span>嗅嗅达人探店</span>
            </div>
            <div class="discription">
              <h3>嗅嗅达人探店</h3>
              <p>达人探店综合解决方案</p>
              <div class="button" @click="routerPush('/home/demo/xxtd')">
                了解详情
              </div>
            </div>
          </li>
        </transition>
        <transition name="zoom"> 
          <li v-if="section4Render">
            <img src="@/assets/lib/images/sec2_25.png" alt />
            <div class="d_title">
              <span>益信种植</span>
            </div>
            <div class="discription">
              <h3>益信种植</h3>
              <p>益信种植综合解决方案</p>
              <div class="button" @click="routerPush('/home/demo/yxzh')">
                了解详情
              </div>
            </div>
          </li>
        </transition>
        <transition name="zoom"> 
          <li v-if="section4Render">
            <img src="@/assets/lib/images/sec2_27.png" alt />
            <div class="d_title">
              <span>重庆三峡柑橘交易中心</span>
            </div>
            <div class="discription">
              <h3>重庆三峡柑橘交易中心</h3>
              <p>重庆三峡柑橘交易中心综合解决方案</p>
              <div class="button" @click="routerPush('/home/demo/gjjys')">
                了解详情
              </div>
            </div>
          </li>
        </transition>
        <transition name="zoom"> 
          <li v-if="section4Render">
            <img src="@/assets/lib/images/sec2_26.png" alt />
            <div class="d_title">
              <span>杏花鸡</span>
            </div>
            <div class="discription">
              <h3>杏花鸡</h3>
              <p>杏花鸡综合解决方案</p>
              <div class="button" @click="routerPush('/home/demo/xhj')">
                了解详情
              </div>
            </div>
          </li>
        </transition>
      </ul>
    </div>

    <div class="section5" ref="section5" v-show="section5RenderShow">
      <ul class="nav clear">
        <li :class="{ active: active == 0 }" @click="activeClick(0)">
          我们的农业生态合作伙伴
          <em></em>
        </li>
        <li :class="{ active: active == 1 }" @click="activeClick(1)">
          我们的数字生态合作伙伴
          <em></em>
        </li>
        <li :class="{ active: active == 2 }" @click="activeClick(2)">
          我们的金融生态合作伙伴
          <em></em>
        </li>
      </ul>
      <div class="w1200 height1"></div>
      <ul class="con1 clear" v-show="active == 0">
        <template v-for="(item, n) in farmingIcons">
          <transition name="zoom" :key="n">
            <li v-if="activeIndex == 0">
              <a class="block">
                <img :src="item.url" />
              </a>
            </li>
          </transition>
        </template>
      </ul>

      <ul class="con2 clear" v-show="active == 1">
        <template v-for="(item, n) in numIcons">
          <transition name="zoom" :key="n">
            <li v-if="activeIndex == 1">
              <a class="block">
                <img :src="item.url" />
              </a>
            </li>
          </transition>
        </template>
      </ul>

      <ul class="con3 clear" v-show="active == 2">
        <template v-for="(item, n) in financialIcons">
          <transition name="zoom" :key="n">
            <li v-if="activeIndex == 2">
              <a class="block">
                <img :src="item.url" />
              </a>
            </li>
          </transition>
        </template>
      </ul>
      <div
        class="button cursor dialogButton"
        @click="
          showDialog = true
          systemId = '4'
        "
      >
        <em class="dialogButton">申请成为X联网解决方案中的一员</em>
        <i class="el-icon-arrow-right dialogButton"></i>
      </div>
    </div>

    <div class="section6" ref="section6" v-show="section6RenderShow">
      <div class="w1200 text-center">
        <transition name="fadeLeftBig">
          <h2 v-if="section6Render">X联网客户合作流程</h2>
        </transition>
        <ul>
          <transition name="fadeRightBig">
            <li v-if="section6Render">
              <img src="@/assets/lib/images/01.png" alt />
              <p>合作咨询</p>
            </li>
          </transition>
          <transition name="fadeRightBig">
            <li v-if="section6Render">
              <img src="@/assets/lib/images/02.png" alt />
              <p>方案沟通</p>
            </li>
          </transition>
          <transition name="fadeRightBig">
            <li v-if="section6Render">
              <img src="@/assets/lib/images/03.png" alt />
              <p>原型确定</p>
            </li>
          </transition>
          <transition name="fadeRightBig">
            <li v-if="section6Render">
              <img src="@/assets/lib/images/04.png" alt />
              <p>封闭开发</p>
            </li>
          </transition>
          <transition name="fadeRightBig">
            <li v-if="section6Render">
              <img src="@/assets/lib/images/05.png" alt />
              <p>测试验收</p>
            </li>
          </transition>
          <transition name="fadeRightBig">
            <li v-if="section6Render">
              <img src="@/assets/lib/images/06.png" alt />
              <p>培训、实施</p>
            </li>
          </transition>
          <transition name="fadeRightBig">
            <li v-if="section6Render">
              <img src="@/assets/lib/images/07.png" alt />
              <p>上线</p>
            </li>
          </transition>
          <transition name="fadeRightBig">
            <li v-if="section6Render">
              <img src="@/assets/lib/images/08.png" alt />
              <p>指导、维护</p>
            </li>
          </transition>
        </ul>

        <div
          class="button cursor dialogButton"
          @click="
            showDialog = true
            systemId = '3'
          "
        >
          <em class="dialogButton">获取最新解决方案</em>
          <i class="el-icon-arrow-right dialogButton"></i>
        </div>
      </div>
    </div>
    <div
      class="section7"
      v-show="
        !section1RenderShow ||
        !section2RenderShow ||
        !section3RenderShow ||
        !section4RenderShow ||
        !section5RenderShow ||
        !section6RenderShow
      "
    ></div>
    <dialog-box
      :showDialog="showDialog"
      :systemId="systemId"
      @close="showDialog = false"
    ></dialog-box>
  </div>
</template>

<script>
import dialogBox from './components/dialog'
export default {
  components: {
    dialogBox,
  },
  data() {
    return {
      section1Render: 3,
      section2Render: 2,
      section3Render: 2,
      section4Render: 2,
      section5Render: 2,
      section6Render: 2,
      section1RenderShow: false,
      section2RenderShow: false,
      section3RenderShow: false,
      section4RenderShow: false,
      section5RenderShow: false,
      section6RenderShow: false,
      sectionActiveRender: 2,
      systemId: '3',
      active: 0,
      activeIndex: 0,
      showDialog: false,
      form: {
        name: '',
        tel: '',
        company: '',
        mail: '',
      },
      farmingIcons: [],
      numIcons: [],
      financailIcons: [],
    }
  },
  created() {
    this.loadFarmingIcon()
    this.loadNumIcon()
    this.loadFinancialIcon()
  },
  mounted() {
    //监听页面滚动事件
    document.addEventListener('scroll', this.scrollHandle)
    setTimeout(() => {
      this.showSection1()
    }, 1000)
  },
  beforeDestroy() {
    //离开这个界面，删除，不然会有问题
    document.removeEventListener('scroll', this.scrollHandle)
  },
  methods: {
    showSection1() {
      if (this.section1Render == 3) {
        this.section1Render = 1 //需要重新渲染
        this.section1RenderShow = true
        this.section2RenderShow = true
      }
      // 重新渲染
      if (this.section1Render == 1) {
        this.section1Render = 0
        this.$nextTick(() => {
          this.section1Render = 2
        })
      }
    },

    activeClick(index) {
      this.$nextTick(() => {
        this.active = index
        this.activeIndex = index
      })
    },
    scrollHandle() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      var offsetTopSection1 = this.$refs['section1'].offsetTop
      //var offsetTopSection3 = this.$refs['section3'].offsetTop
      //var offsetTopSection4 = this.$refs['section4'].offsetTop
      //var offsetTopSection6 = this.$refs['section6'].offsetTop
      // console.log(
      //   '====',
      //   scrollTop,
      //   offsetTopSection1,
      //   offsetTopSection3,
      //   offsetTopSection4,
      //   offsetTopSection6,
      // )

      if (scrollTop < 3 * offsetTopSection1 && !this.section3RenderShow) {
        this.section3Render = 3
      } else if (this.section3Render == 3) {
        this.section3RenderShow = true
        this.section3Render = 1 //需要重新渲染
      }
      if (scrollTop < 4 * offsetTopSection1 && !this.section4RenderShow) {
        this.section4Render = 3
      } else if (this.section4Render == 3) {
        this.section4RenderShow = true
        this.section4Render = 1 //需要重新渲染
      }
      if (scrollTop < 7 * offsetTopSection1 && !this.section6RenderShow) {
        this.section6Render = 3
      } else if (this.section6Render == 3) {
        this.section6RenderShow = true
        this.section6Render = 1 //需要重新渲染
      }
      if (scrollTop > 2500 && scrollTop < 3050) {
        if (this.sectionActiveRender == 2) {
          this.section5RenderShow = true
          this.active = 3
          this.activeIndex = 3
          this.sectionActiveRender = 0
          this.activeClick(0)
        }
      }

      // 重新渲染
      if (this.section3Render == 1) {
        this.section3Render = 0
        this.$nextTick(() => {
          this.section3Render = 2
        })
      }
      // 重新渲染
      if (this.section4Render == 1) {
        this.section4Render = 0
        this.$nextTick(() => {
          this.section4Render = 2
        })
      }
      // 重新渲染
      if (this.section6Render == 1) {
        this.section6Render = 0
        this.$nextTick(() => {
          this.section6Render = 2
        })
      }
    },
    routerPush(url) {
      window.open(url)
    },
    loadFarmingIcon() {
      var i = 1
      var list = []
      while (i <= 56) {
        list.push({
          url: require('@/assets/lib/images/farming/farming_' + i + '.png'),
        })
        i = i + 1
      }
      this.farmingIcons = list
    },
    loadNumIcon() {
      var i = 1
      var list = []
      while (i <= 49) {
        list.push({
          url: require('@/assets/lib/images/num/num_' + i + '.png'),
        })
        i = i + 1
      }
      this.numIcons = list
    },
    loadFinancialIcon() {
      var list = []
      for (var i = 1; i <= 8; i++) {
        if (i==2) {
          continue;
        }
        list.push({
          url: require('@/assets/lib/images/financial/sec1_' + i + '.png'),
        })
      }
      for (var m = 1; m <= 5; m++) {
        list.push(
          {
            url: require('@/assets/lib/images/financial/sec2_' + m + '.png'),
          },
          {
            url: require('@/assets/lib/images/financial/sec3_' + m + '.png'),
          },
          {
            url: require('@/assets/lib/images/financial/sec4_' + m + '.png'),
          },
        )
      }
      this.financialIcons = list
    },
  },
}
</script>

<style lang="scss">
@import '~@/assets/pc/css/home.scss';
</style>
